module.exports = __webpack_public_path__ + "media/images/benefit-reseller-19f9c4b19b767c5449b7abbb011a7bfd.svg";